module.exports = __webpack_public_path__ + "img/weddings_11_V.126abd9a.webp";